import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FirmwarePacket } from 'app/models/firmwarePacket.model';
import { FirmwareService } from 'app/services/firmware.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-firmware-detail',
    templateUrl: './firmware-detail.component.html',
    styleUrls: ['./firmware-detail.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class FirmwareDetailComponent implements OnInit {
    widgets: any;

    private _lastPacket: FirmwarePacket;

    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;
    private _packetList: Array<FirmwarePacket> = [];
    public get packetList(): Array<FirmwarePacket> {
        return this._packetList;
    }



    private _dataSource: MatTableDataSource<FirmwarePacket> = undefined;
    public get dataSource(): MatTableDataSource<FirmwarePacket> {
        return this._dataSource;
    }

    private _displayedColumns = ['rowNum', 'packet'];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        private _firmwareService: FirmwareService,
        private _spinner:NgxSpinnerService,
        private route: ActivatedRoute
    ) {

    }


    public async ngOnInit() {
        let firmwareId: string;
        this.route.queryParamMap.subscribe(params => {

            firmwareId = params['params']['firmwareId']
        });
        try {
            this._spinner.show('loading')
            await this.getPacketList(firmwareId);
            this._spinner.hide('loading')
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);

        }
        this.updateTableDataSource();
    }
    private async getPacketList(firmwareId: string): Promise<Array<FirmwarePacket>> {
        try {
            this._spinner.show('loading')
            this._packetList = await this._firmwareService.getFirmwarePacket(firmwareId);
            this._spinner.hide('loading')
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
            return [];
        }
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<FirmwarePacket>(this._packetList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }
}
